
define('eteration/ui/faqsearch-viewmodel',['jquery',
        'knockout',
        'eteration/eteration-ajax',
				'ui-helper/storage-helper',
        'eteration/widgets/ui-i18n',
        'eteration/eteration',
        'eteration/ui/form-viewmodel',
        'eteration/eteration-i18n'
        ], 
function($,ko,etrAjax,storageHelper,ui18,Eteration,BaseViewModel,FaqSearchBar,i18n) {

	function SearchVM(){
		var self = this; 
		ko.utils.extend(self, new BaseViewModel.FormViewModel());

		var language;
		var country;


		self.callCenterLink = ko.observable(faqsearchLinks.callCenter);
		self.feedbackFormLink = ko.observable(faqsearchLinks.feedbackForm);
		

		self.param = ko.observable();
		self.queryParam = ko.observable();

		self.redirectPage = function (){
			storageHelper.setItem({
				key: "FAQ_KEY",
				value: self.queryParam(),
				webStorageType: storageHelper.Stores.SESSION_STORAGE
			});
			window.location = faqsearchLinks.faqHome; 
		}
		
		self.faqsearch = function(keyword){
			self.param(keyword);
			self.search();
		}

		$(function() {
			$( "#searchBoxTextTyped" ).autocomplete({
				source: function( request, responseSource ) {
					etrAjax.post({
						app : 'app.search',
						service : '/faqsearch/searchresultfromtypeahead',
						data: { parameter: request.term, langCountryCode: self.langCountryCode },
						disableLoader:true,
						disableErrorHandling:true,
						callback : function(response) {
							var faqItems = new Array();
							ko.utils.arrayForEach(response.data, function(item) {
								faqItems.push(item.replace(/\+/g, ' '));
							});
							responseSource(faqItems);
						}
					});
				},
				minLength: 3,
				delay: 500,
				appendTo: "#help #form1"
			});
		});

		$("#searchBoxTextTyped").keyup(function(event) {
			if (event.keyCode == 13) {    
				self.queryParam($(this).val());
	        	self.redirectPage();
	        	return false;
	        }
        });
		$(document).on('keyup',function(evt) {
		    if (evt.keyCode == 27) {
		       if($('#faq-modal').hasClass('in')){
		    	   $('#FaqSeachBtn').click();
		    	   $('#FaqSearchBtn').click();
		       }
		    }
		});

		$(function () {
			$("#searchBoxTextTyped").on("keypress", function (e) {
				var charCode = String.fromCharCode(e.which || e.keyCode);
				var regex = /^[A-Za-z0-9 çğıİöÖşŞüÜ]$/;
				if (!regex.test(charCode)) {
					e.preventDefault();
				}
			});
		});
				
		self.search = function(){
			etrAjax.get({
				app: 'app.search',
				service:'/faqsearch/faq/' + self.param().text,
				callback:function(response) {
					console.log('alert');
				}
			});
		}
		
		self.langCountryCode = $('meta[name=languagecountry]').attr("content");
		if(self.langCountryCode != null && self.langCountryCode != "")
		{
			var langCountry = self.langCountryCode;
			var langCountryPair  = langCountry.split("-"); 
			if(langCountryPair.length == 2)
			{	
				language = langCountryPair[0];
				country = langCountryPair[1];
			}
		}
		self.closeFaqSearch = function() {
			$('#FaqSeachBtn').click();
			$('#FaqSearchBtn').click();
		}
	}

	return { ViewModel:  SearchVM };
});
